module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0001",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "intr-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0004"
    }
  }, [_c('em', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0005"
    }
  }, [_vm._v("THE LAST PENNANT BEFORE ARMAGEDDON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE BASEBALL SPUR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HOW I GOT MY NICKNAME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BUD AND TOM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NURSIE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE NIGHT MANNY MOTA TIED THE RECORD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DRIVING TOWARD THE MOON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BAREFOOT AND PREGNANT IN DES MOINES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE FIREFIGHTER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE BATTERY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "chap-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE THRILL OF THE GRASS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ack-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0016",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "auth-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0017",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("About the Author")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eb0ed14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0003.vue
// module id = 69
// module chunks = 0